export const INITIALIZING = 'initializing';
export const FILTERING = 'filtering';
export const SEARCHING = 'searching';
export const SORTING = 'sorting';
